import { ApolloModule } from 'apollo-angular';

import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { S2AFlexModule } from '@s2a-core/flex';
import { AuthHttpInterceptor, FileModule, NgCoreModule } from '@s2a-core/ng-core';
import { RoughTimePipe } from '@s2a-core/ng-pipes';
import { EquipmentCoreModule } from '@s2a-equipment/ng-core';
import { AuthService, Environment } from '@s2a/core';

import { NgShellModule, SessionService } from '~ng-shell';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppMaterialModule } from './app.material.module';
import { AppRoutingModule } from './app.router';
import { AppBellComponent } from './components/app-bell/app-bell.component';
import { NotificationTimelineComponent } from './components/notification-timeline/notification-timeline.component';
import { PureHistoryDividerComponent } from './components/notification-timeline/timeline/divider/pure-history-divider.component';
import { PureFilterPanelComponent } from './components/notification-timeline/timeline/filter/filter-panel/pure-filter-panel.component';
import { PureTimelineFilterComponent } from './components/notification-timeline/timeline/filter/pure-timeline-filter.component';
import { PureTimelineHeaderComponent } from './components/notification-timeline/timeline/header/pure-timeline-header.component';
import { PureHistoryItemComponent } from './components/notification-timeline/timeline/history-item/pure-history-item.component';
import { PureTimelineComponent } from './components/notification-timeline/timeline/pure-timeline.component';
import { VirtualHistoryItemComponent } from './components/notification-timeline/timeline/virtual-history-item/virtual-history-item.component';
import { ShellComponent } from './components/shell/shell.component';
import { PureListItemComponent } from './components/sidenav/list-item/pure-list-item.component';
import { PureSidenavComponent } from './components/sidenav/pure-sidenav/pure-sidenav.component';
import { PureSidenavSkeletonComponent } from './components/sidenav/sidenav-skeleton/pure-sidenav-skeleton.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ComponentLifecycleManager } from './services/component.service';
import { RouterService } from './services/router.service';
import { setSessionFactory } from './services/session-factory.service';
import { ShellAuthenticationService } from './services/shell-authentication.service';

@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    PureSidenavComponent,
    PureSidenavSkeletonComponent,
    PureListItemComponent,
    ShellComponent,
    NotificationTimelineComponent,
    PureHistoryDividerComponent,
    PureHistoryItemComponent,
    PureTimelineHeaderComponent,
    PureTimelineComponent,
    PureTimelineFilterComponent,
    PureFilterPanelComponent,
    AppBellComponent,
    VirtualHistoryItemComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    AppMaterialModule,
    NgShellModule.forRoot(environment as Environment),
    NgCoreModule.forRoot(environment as Environment),
    S2AFlexModule,
    FileModule.forRoot(environment as Environment),
    EquipmentCoreModule.forRoot(environment as Environment),
    ApolloModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    SessionService,
    ComponentLifecycleManager,
    ShellAuthenticationService,
    {
      provide: Environment,
      useValue: environment,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: setSessionFactory,
      deps: [ShellAuthenticationService, SessionService, RouterService, AuthService],
      multi: true,
    },
    RoughTimePipe,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
